module.exports = "https://web-assets.ifttt.com/packs/media/connect/double-arrow-777342e4.svg";